import { IInvestorDetails } from 'src/app/models/registration/investorDetails';

export interface IInvestorDetailsState {
    details: IInvestorDetails;
    failText: string | null;
}

export const initialInvestorDetailsState: IInvestorDetailsState = {
    details: undefined,
    failText: null
};
